import { render, staticRenderFns } from "./AsiBreadcrumbs.vue?vue&type=template&id=85b1cf1a&scoped=true"
import script from "./AsiBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./AsiBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./AsiBreadcrumbs.vue?vue&type=style&index=0&id=85b1cf1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b1cf1a",
  null
  
)

export default component.exports